import React from 'react';

import {
  SectionHeader,
  Subsection,
  SuccessBox,
  TabSection,
} from './_shared';

function Missions() {
  return (
    <div>
      <TabSection>
        <SectionHeader title={<span><span role="img" aria-label="star">🌟</span> A. ÊTRE MIS EN AVANT DANS LA COMMUNICATION</span>} />
        <Subsection>
          <ul style={{ marginLeft: '25px' }}>
            <li style={{ marginBottom: '10px' }}>Dans les 4 newsletters envoyées tous les trimestres traitant de sujet sur la copropriété et le présentant à chaque fois</li>
            <li style={{ marginBottom: '10px' }}>Dans 2 campagnes supplémentaires aux newsletters : envoi de mails ou de courriers RGPD COMPATIBLE</li>
            <li style={{ marginBottom: '10px' }}>Dans les mails envoyés chaque semaine aux copropriétaires qui réalisent un DPE (mise à jour de nouveaux DPE du parc tous les mercredis)</li>
            <li style={{ marginBottom: '10px' }}>Dans les échanges qu'il aura avec ces copropriétaires pour parler de leur projet immobilier lié à ce DPE</li>
          </ul>
        </Subsection>
      </TabSection>

      <TabSection>
        <SectionHeader title={<span><span role="img" aria-label="speech bubble">💬</span> B. RÉPONDRE AUX COPROPRIÉTAIRES QUI LE SOLLICITENT</span>} />
        <Subsection>
          <ul style={{ marginLeft: '25px' }}>
            <li style={{ marginBottom: '10px' }}>Par des appels entrants du fait de sa mise en avant dans les opérations de communication : newsletters, mailing…</li>
            <li style={{ marginBottom: '10px' }}>Par les appels qu'il fait lui-même aux copropriétaires qui ont réalisé un DPE</li>
          </ul>
          <p style={{ marginTop: '20px', textAlign: 'justify' }}>
            Dans les 2 cas son rôle est de les accompagner s'ils ont un projet de vente ou de location, mais <strong>uniquement sur leurs obligations liées au fait que leur bien se trouve dans une copropriété</strong> et à la fin de l'échange de leur proposer un rendez-vous avec le service transaction ou gestion locative en fonction de leurs besoins.
          </p>
        </Subsection>

        <SuccessBox title={(
          <span><span role="img" aria-label="target">🎯</span> 3 objectifs :</span>
        )}>
          <p><strong>1. Pour le copropriétaire :</strong> Vous simplifier les démarches et sécuriser les échanges</p>
          <p><strong>2. Pour le syndic :</strong> Communiquer en permanence sur ce nouveau service et favoriser la prise de contact d'un copropriétaire avant même qu'il ait effectué une démarche avec un autre professionnel de l'immobilier</p>
          <p><strong>3. Pour obtenir le consentement :</strong> Des copropriétaires à être mis en relation avec les services de transactions et de gestion locative</p>
        </SuccessBox>
      </TabSection>

      <TabSection>
        <SectionHeader title={<span><span role="img" aria-label="clipboard">📋</span> MISSIONS DU RÉFÉRENT AU QUOTIDIEN</span>} />
        <Subsection>
          <ul style={{ marginLeft: '25px' }}>
            <li style={{ marginBottom: '10px' }}><strong>Suivre avec le dirigeant la stratégie de communication définie :</strong> qualifier les copropriétés avec le plus de potentiel, qualifier les contacts des SCI, définir les dates de boitages pour le service transaction et/ou gestion locative...</li>
            <li style={{ marginBottom: '10px' }}><strong>Valider les nouveaux DPE :</strong> Qui sortent toutes les semaines et prendre contact avec les copropriétaires</li>
            <li style={{ marginBottom: '10px' }}><strong>Être présent aux AG des copropriétés à fort potentiel :</strong> Aller se présenter aux assemblées générales des copropriétés où il y a le plus de ventes par an</li>
            <li style={{ marginBottom: '10px' }}><strong>Préparer les documents à mettre sur les tables des AG où il ne sera pas présent :</strong> et les donner au gestionnaire</li>
            <li style={{ marginBottom: '10px' }}><strong>Réponse aux appels entrants :</strong> Des copropriétaires qui prendront directement contact avec lui</li>
            <li style={{ marginBottom: '10px' }}><strong>Mettre en relation et/ou fixer les rendez-vous des copropriétaires qui le souhaitent avec les services :</strong> transaction, gestion locative</li>
          </ul>
        </Subsection>
      </TabSection>
    </div>
  );
}

export default Missions;


